export default "__VITE_ASSET__DOiwwWxK__"